import { html } from 'htm/preact';
import { render } from 'preact';
import { useEffect, useState } from 'react';
import { EclipseDoc, fetchEclipseData } from '@utils/eclipse2026';
import { MapGeoDoc, fetchMapGeo } from './lib/mapGeo';
import { getLeaflet } from './lib/leaflet';
import { App } from './components/App';

const container = document.querySelector<HTMLDivElement>('#eclipse-iberico-2026');

/**
 * Estado de carregamento próprio, em vez de mostrar App só quando os dois fetches
 * terminam: o `.eclipse-shell--placeholder` na blade já reserva os 800 px (evita
 * CLS), e este componente escreve directamente por cima dele.
 *
 * O Leaflet é verificado aqui e não dentro do mapa: se o vendor (`leaflet-js`) não
 * tiver carregado, isto é um erro de enqueue, não uma falha de dados — vale a pena
 * distingui-lo na mensagem em vez de deixar um rectângulo cinzento sem explicação.
 */
function Root({ jsonUrl, mapUrl }: { jsonUrl: string; mapUrl: string }) {
    const [state, setState] = useState<{ doc: EclipseDoc; geo: MapGeoDoc } | 'loading' | 'error' | 'no-leaflet'>('loading');

    useEffect(() => {
        if (!getLeaflet()) {
            setState('no-leaflet');
            return;
        }
        Promise.all([fetchEclipseData(jsonUrl), fetchMapGeo(mapUrl)])
            .then(([doc, geo]) => setState({ doc, geo }))
            .catch(() => setState('error'));
    }, [jsonUrl, mapUrl]);

    if (state === 'loading') return html`<div class="eclipse-status">A carregar o mapa do eclipse…</div>`;
    if (state === 'no-leaflet') return html`<div class="eclipse-status">Não foi possível carregar a biblioteca do mapa.</div>`;
    if (state === 'error') return html`<div class="eclipse-status">Não foi possível carregar os dados do eclipse. <a href=${location.href}>Tentar de novo</a>.</div>`;
    return html`<${App} doc=${state.doc} geo=${state.geo} />`;
}

if (container) {
    const { jsonUrl, mapUrl } = container.dataset;
    if (jsonUrl && mapUrl) {
        render(html`<${Root} jsonUrl=${jsonUrl} mapUrl=${mapUrl} />`, container);
    }
}
